export default "__VITE_ASSET__B7V2U01b__"